import React from 'react';

const LandingPageComponent = () => {
  return (
    <div className="font-sans antialiased text-gray-900">
      
      {/* Navigation */}
      <nav className="bg-white/95 backdrop-blur-sm border-b border-gray-200 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center space-x-3">
              <div className="bg-gradient-to-r from-slate-700 to-slate-800 p-2 rounded-lg">
                <svg className="h-6 w-6 text-orange-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"/>
                </svg>
              </div>
              <div>
                <h1 className="text-xl font-bold text-slate-800">
                  TICK<span className="text-orange-500">L</span>ER
                </h1>
              </div>
            </div>
            
            {/* Desktop menu */}
            <div className="hidden md:flex items-center space-x-4">
              <a href="#features" className="text-gray-700 hover:text-gray-900 font-medium">Features</a>
              <a href="#pricing" className="text-gray-700 hover:text-gray-900 font-medium">Pricing</a>
              <button onClick={() => window.location.href = '/'} className="bg-orange-500 hover:bg-orange-600 text-white px-6 py-2 rounded-lg font-semibold transition-colors">
                Get Started
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="gradient-bg hero-pattern relative overflow-hidden">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-24" style={{background: 'linear-gradient(135deg, #1e293b 0%, #334155 100%)'}}>
          <div className="text-center">
            <h1 className="text-3xl sm:text-4xl md:text-6xl font-bold text-white mb-4 sm:mb-6 leading-tight">
              IDEAS WORTH VETTING
            </h1>
            <p className="text-lg sm:text-xl md:text-2xl text-slate-300 mb-6 sm:mb-8 max-w-3xl mx-auto px-4">
              Track and organize investment ideas from X bookmarks. Save ideas, organize them automatically, and get reminded to research the ones you want to learn more about.
            </p>
            <div className="text-center space-y-3 sm:space-y-4 px-4">
              <div>
                <button onClick={() => window.location.href = '/'} className="w-full sm:w-auto bg-orange-500 hover:bg-orange-600 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg text-base sm:text-lg font-semibold transition-colors">
                  Start Organizing Your Ideas
                </button>
              </div>
              <div>
                <button onClick={() => document.getElementById('features').scrollIntoView({behavior: 'smooth'})} className="w-full sm:w-auto border-2 border-white/30 text-white hover:bg-white/10 px-6 sm:px-8 py-3 sm:py-4 rounded-lg text-base sm:text-lg font-semibold transition-colors">
                  See How It Works
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Problem Section */}
      <section id="features" className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-12">
            Stop Losing Good Ideas
          </h2>
          
          <div className="grid md:grid-cols-3 gap-8 mb-16">
            <div className="bg-white p-6 rounded-xl border border-gray-200">
              <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center mx-auto mb-4">
                <svg className="w-6 h-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"/>
                </svg>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Lost in Bookmarks</h3>
              <p className="text-gray-600">Good investment ideas disappear in your X bookmarks with no system to organize them.</p>
            </div>
            
            <div className="bg-white p-6 rounded-xl border border-gray-200">
              <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center mx-auto mb-4">
                <svg className="w-6 h-6 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
                </svg>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">No Follow-up</h3>
              <p className="text-gray-600">You save the idea but have no system to remind yourself to research it later.</p>
            </div>
            
            <div className="bg-white p-6 rounded-xl border border-gray-200">
              <div className="w-12 h-12 bg-gray-100 rounded-lg flex items-center justify-center mx-auto mb-4">
                <svg className="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"/>
                </svg>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">Scattered Everywhere</h3>
              <p className="text-gray-600">Ideas are scattered everywhere with no system to track or prioritize them.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Solution Section */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Your Personal Investment Filing System
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Save investment ideas from X, organize them automatically, and get reminded to research the ones you want to dive deeper on.
          </p>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-16 items-center mb-16">
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Filing System That Actually Works
              </h3>
              <p className="text-lg text-gray-600 mb-6">
                See your ideas worth vetting and ready for research. No more losing track of interesting opportunities you wanted to explore.
              </p>
              <ul className="space-y-3">
                <li className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-green-500 rounded-full mt-2"></div>
                  <span className="text-gray-700">Fresh ideas ready for research</span>
                </li>
                <li className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-orange-500 rounded-full mt-2"></div>
                  <span className="text-gray-700">Ideas you've been meaning to research</span>
                </li>
                <li className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-red-500 rounded-full mt-2"></div>
                  <span className="text-gray-700">Ideas that need attention</span>
                </li>
              </ul>
            </div>
            <div className="bg-gradient-to-br from-slate-50 to-slate-100 p-8 rounded-xl">
              {/* Real Investment Ideas Dashboard Screenshot */}
              <div className="bg-white rounded-lg shadow-lg overflow-hidden">
                <div className="p-4">
                  <img src="/investment_ideas_dashboard.jpg" 
                       alt="Investment Ideas Dashboard - Real Application Interface" 
                       className="w-full rounded-lg shadow-lg border border-gray-200" />
                </div>
              </div>
            </div>
          </div>

          <div className="grid lg:grid-cols-2 gap-16 items-center mb-16">
            <div className="bg-gradient-to-br from-orange-50 to-orange-100 p-8 rounded-xl lg:order-1">
              {/* Real Ask for Ideas Tab Screenshot */}
              <div className="bg-white rounded-lg shadow-lg overflow-hidden">
                <div className="p-4">
                  <img src="/ask_for_ideas_tab.jpg" 
                       alt="Ask for Ideas Tab - Investment Polls Interface" 
                       className="w-full rounded-lg shadow-lg border border-gray-200" />
                </div>
              </div>
            </div>
            <div className="lg:order-2">
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Poll Your Network for Investment Ideas
              </h3>
              <p className="text-lg text-gray-600 mb-6">
                Create X polls or ask for open-ended investment recommendations. The same interface you see in your dashboard - responses get collected automatically with @savetotickler.
              </p>
              <ul className="space-y-3">
                <li className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-orange-500 rounded-full mt-2"></div>
                  <span className="text-gray-700">Two modes: X polls or open-ended idea requests</span>
                </li>
                <li className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-orange-500 rounded-full mt-2"></div>
                  <span className="text-gray-700">Pre-populated templates for common investment questions</span>
                </li>
                <li className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-orange-500 rounded-full mt-2"></div>
                  <span className="text-gray-700">All responses automatically tracked with @savetotickler mention</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="grid lg:grid-cols-2 gap-16 items-center mb-16">
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Research Reminders & Scheduling
              </h3>
              <p className="text-lg text-gray-600 mb-6">
                Set up reminders to research ideas you want to learn more about. Schedule research sessions and never forget to follow up on promising opportunities.
              </p>
              <ul className="space-y-3">
                <li className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-purple-500 rounded-full mt-2"></div>
                  <span className="text-gray-700">Auto-categorized watchlists by industry</span>
                </li>
                <li className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-purple-500 rounded-full mt-2"></div>
                  <span className="text-gray-700">Email reminders for research follow-up</span>
                </li>
                <li className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-purple-500 rounded-full mt-2"></div>
                  <span className="text-gray-700">Calendar scheduling for deep research</span>
                </li>
              </ul>
            </div>
            <div className="bg-gradient-to-br from-purple-50 to-purple-100 p-8 rounded-xl">
              {/* Real Scheduling Popup Screenshot */}
              <div className="bg-white rounded-lg shadow-lg overflow-hidden">
                <div className="p-4">
                  <img src="/scheduling_popup.jpg" 
                       alt="Research Scheduling Interface - Real Application Modal" 
                       className="w-full rounded-lg shadow-lg border border-gray-200" />
                </div>
              </div>
            </div>
          </div>

          <div className="grid lg:grid-cols-2 gap-16 items-center mb-16">
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                Generate SEC Filing Collections
              </h3>
              <p className="text-lg text-gray-600 mb-6">
                Create comprehensive SEC filings documents for your research. Choose which filings to include: 10-K annual reports, 10-Q quarterly reports, 8-K current reports, proxy statements, and financial statements.
              </p>
              <ul className="space-y-3">
                <li className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-slate-500 rounded-full mt-2"></div>
                  <span className="text-gray-700">Comprehensive SEC filing research</span>
                </li>
                <li className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-slate-500 rounded-full mt-2"></div>
                  <span className="text-gray-700">Professional PDF format with XBRL financial data</span>
                </li>
                <li className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-slate-500 rounded-full mt-2"></div>
                  <span className="text-gray-700">Interactive web viewer with BamSEC-style navigation</span>
                </li>
              </ul>
            </div>
            <div className="bg-gradient-to-br from-slate-50 to-slate-100 p-8 rounded-xl">
              {/* Real Document Creation Page Screenshot */}
              <div className="bg-white rounded-lg shadow-lg overflow-hidden">
                <div className="p-4">
                  <img src="/document_creation_page.jpg" 
                       alt="SEC Filings Collection Interface - Real Application Modal" 
                       className="w-full rounded-lg shadow-lg border border-gray-200" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section id="pricing" className="py-24 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
              Simple Pricing
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Start free, upgrade when you're ready for more.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            {/* Free Plan */}
            <div className="bg-white rounded-2xl p-8 border-2 border-gray-200">
              <div className="text-center mb-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-2">Free</h3>
                <div className="text-4xl font-bold text-gray-900 mb-2">$0</div>
                <p className="text-gray-600">Try it out</p>
              </div>
              <ul className="space-y-4 mb-8">
                <li className="flex items-start space-x-3">
                  <svg className="w-5 h-5 text-green-500 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"/>
                  </svg>
                  <span className="text-gray-700">5 investment ideas</span>
                </li>
                <li className="flex items-start space-x-3">
                  <svg className="w-5 h-5 text-green-500 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"/>
                  </svg>
                  <span className="text-gray-700">Freshness tracking</span>
                </li>
                <li className="flex items-start space-x-3">
                  <svg className="w-5 h-5 text-green-500 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"/>
                  </svg>
                  <span className="text-gray-700">X integration</span>
                </li>
                <li className="flex items-start space-x-3">
                  <svg className="w-5 h-5 text-green-500 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"/>
                  </svg>
                  <span className="text-gray-700">Basic watchlists</span>
                </li>
              </ul>
              <button onClick={() => window.location.href = '/'} className="w-full bg-gray-700 hover:bg-gray-800 text-white py-3 px-6 rounded-lg font-semibold transition-colors">
                Start Free
              </button>
            </div>

            {/* Pro Plan */}
            <div className="bg-orange-50 rounded-2xl p-8 border-2 border-orange-500 relative">
              <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                <span className="bg-orange-500 text-white px-4 py-2 rounded-full text-sm font-semibold">Most Popular</span>
              </div>
              <div className="text-center mb-8">
                <h3 className="text-2xl font-bold text-gray-900 mb-2">Pro</h3>
                <div className="text-4xl font-bold text-gray-900 mb-2">$39<span className="text-lg text-gray-600">/month</span></div>
                <p className="text-gray-600">Billed annually ($468/year)</p>
                <p className="text-sm text-green-600 font-medium mt-1">Or $49/month billed monthly</p>
              </div>
              <ul className="space-y-4 mb-8">
                <li className="flex items-start space-x-3">
                  <svg className="w-5 h-5 text-green-500 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"/>
                  </svg>
                  <span className="text-gray-700">Unlimited investment ideas</span>
                </li>
                <li className="flex items-start space-x-3">
                  <svg className="w-5 h-5 text-green-500 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"/>
                  </svg>
                  <span className="text-gray-700">Email reminders</span>
                </li>
                <li className="flex items-start space-x-3">
                  <svg className="w-5 h-5 text-green-500 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"/>
                  </svg>
                  <span className="text-gray-700">Calendar integration</span>
                </li>
                <li className="flex items-start space-x-3">
                  <svg className="w-5 h-5 text-green-500 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"/>
                  </svg>
                  <span className="text-gray-700">Advanced watchlists</span>
                </li>
                <li className="flex items-start space-x-3">
                  <svg className="w-5 h-5 text-green-500 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"/>
                  </svg>
                  <span className="text-gray-700">Research scheduling</span>
                </li>
                <li className="flex items-start space-x-3">
                  <svg className="w-5 h-5 text-green-500 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"/>
                  </svg>
                  <span className="text-gray-700">SEC filing generation</span>
                </li>
              </ul>
              <button onClick={() => window.location.href = '/'} className="w-full bg-orange-500 hover:bg-orange-600 text-white py-3 px-6 rounded-lg font-semibold transition-colors">
                Start Pro Trial
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 bg-slate-900">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6">
            Never lose track of investment ideas again.
          </h2>
          <p className="text-xl text-slate-300 mb-8 max-w-2xl mx-auto">
            Start vetting your ideas today.
          </p>
          <div className="space-y-4 sm:space-y-0 sm:space-x-4 sm:flex sm:justify-center">
            <button onClick={() => window.location.href = '/'} className="w-full sm:w-auto bg-orange-500 hover:bg-orange-600 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-colors">
              Start Organizing Your Ideas
            </button>
            <button className="w-full sm:w-auto border-2 border-white/30 text-white hover:bg-white/10 px-8 py-4 rounded-lg text-lg font-semibold transition-colors">
              See Features
            </button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-slate-800 py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="flex items-center space-x-3 mb-4 md:mb-0">
              <div className="bg-gradient-to-r from-slate-600 to-slate-700 p-2 rounded-lg">
                <svg className="h-5 w-5 text-orange-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"/>
                </svg>
              </div>
              <span className="text-lg font-bold text-white">
                TICK<span className="text-orange-500">L</span>ER
              </span>
            </div>
            
            <div className="flex flex-col md:flex-row items-center space-y-4 md:space-y-0 md:space-x-8">
              <div className="text-sm text-slate-400">
                © 2025 Tickler. All rights reserved.
              </div>
              <div className="flex space-x-6">
                <a href="#" className="text-slate-400 hover:text-white text-sm">Privacy Policy</a>
                <a href="#" className="text-slate-400 hover:text-white text-sm">Terms of Service</a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LandingPageComponent;